// return a middleware to set cache-control header
// default period is 30 days
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "getCacheMiddleware", {
    enumerable: true,
    get: function() {
        return getCacheMiddleware;
    }
});
const getCacheMiddleware = (period = 2592000)=>{
    return async (req, res, next)=>{
        const { method } = req;
        // only cache GET requests
        if (method === 'GET') {
            // set cache-control header
            res.set('Cache-Control', `public, max-age=${period}`);
        }
        next();
    };
};
